import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

/**DATOS DUMMY DE VISITAS INICIALES */
const dataInicial2 = {
    inspectores: [
        {
            id: 1,
            titulo: 'Q.F.B.',
            nombre: 'ELIOENAI',
            apellidos: 'GAYTAN VENTURA',
            puesto: 'gerente',
            estatus: 'activo',
            laptop: '1',
            celular: '951 346 7952',
            tarjeta: '5062 5416 0249 4525',
            vehiculo: 'honda city',
            imagen: 'https://auth.gcefe.com/storage/users/photos/88SH4Fwui5XQ3uNK236HOcBsXD2AMxGiq9RIaF1D.png',
            tutor: '',
            acreditacion: ''
        }, {
            id: 2,
            titulo: 'I.Q',
            nombre: 'UZIEL',
            apellidos: 'CRUZ BORJAS',
            puesto: 'subgerente',
            estatus: 'activo',
            laptop: '2',
            celular: '951 231 0883',
            tarjeta: '5062 5416 0249 4525',
            vehiculo: 'honda city',
            imagen: 'http://www.masterups.mx/wp-content/uploads/2019/06/ejecutivo-exitoso-png-9.png',
            tutor: '',
            acreditacion: ''
        }, {
            id: 3,
            titulo: 'ING. AGR.',
            nombre: 'José Alfredo',
            apellidos: 'CRUZ VELASCO',
            puesto: 'subgerente',
            estatus: 'activo',
            laptop: '4',
            celular: '9512446196',
            tarjeta: '5062 5416 0249 4525',
            vehiculo: 'honda city',
            imagen: 'https://www.trendtic.cl/wp-content/uploads/2018/05/003-Rub%C3%A9n-Belluomo-INFOR-2018.jpg',
            tutor: '',
            acreditacion: ''
        }, {
            id: 4,
            titulo: 'I.B.Q.',
            nombre: 'CARLOS',
            apellidos: 'VALENCIA MOLINA',
            puesto: 'inspector',
            estatus: 'activo',
            laptop: '3',
            celular: '951 475 0362',
            tarjeta: '5062 5416 0249 4525',
            vehiculo: 'honda city',
            imagen: 'http://www.cass-mex.com/images/img-consultoria.png',
            tutor: '',
            acreditacion: ''
        }, {
            id: 5,
            titulo: 'ING.',
            nombre: 'HUGO',
            apellidos: 'BAUTISTA GARCIA',
            puesto: 'inspector',
            estatus: 'activo',
            laptop: '6',
            celular: '442 232 3303',
            tarjeta: '5062 5416 0249 4525',
            vehiculo: 'honda city',
            imagen: 'https://auth.gcefe.com/storage/users/photos/88SH4Fwui5XQ3uNK236HOcBsXD2AMxGiq9RIaF1D.png',
            tutor: '',
            acreditacion: ''
        }, {
            id: 6,
            titulo: 'I.T.B.',
            nombre: 'DANIEL CELESTINO',
            apellidos: 'MERINO LOPEZ',
            puesto: 'inspector',
            estatus: 'activo',
            laptop: '7',
            celular: '442 232 3303',
            tarjeta: '5062 5416 0238 9899',
            vehiculo: 'honda city',
            imagen: 'http://www.masterups.mx/wp-content/uploads/2019/06/ejecutivo-exitoso-png-9.png',
            tutor: '',
            acreditacion: ''
        }, {
            id: 7,
            titulo: 'ING.',
            nombre: 'AZARIEL JULIAN',
            apellidos: 'RIOS',
            puesto: 'inspector',
            estatus: 'activo',
            laptop: '8',
            celular: '442 232 3303',
            tarjeta: '5062 5416 0249 4525',
            vehiculo: 'honda city',
            imagen: 'http://www.cass-mex.com/images/img-consultoria.png',
            tutor: '',
            acreditacion: ''
        }, {
            id: 8,
            titulo: 'ING. AGR.',
            nombre: 'AZARIEL JULIAN',
            apellidos: 'RIOS',
            puesto: 'inspector',
            estatus: 'activo',
            laptop: '8',
            celular: '442 232 3303',
            tarjeta: '5062 5416 0249 4525',
            vehiculo: 'honda city',
            imagen: 'https://www.trendtic.cl/wp-content/uploads/2018/05/003-Rub%C3%A9n-Belluomo-INFOR-2018.jpg',
            tutor: '',
            acreditacion: ''
        }, {
            id: 9,
            titulo: 'ING. AGR.',
            nombre: 'AZARIEL JULIAN 9',
            apellidos: 'RIOS',
            puesto: 'inspector',
            estatus: 'activo',
            laptop: '8',
            celular: '442 232 3303',
            tarjeta: '5062 5416 0249 4525',
            vehiculo: 'honda city',
            imagen: 'https://www.trendtic.cl/wp-content/uploads/2018/05/003-Rub%C3%A9n-Belluomo-INFOR-2018.jpg',
            tutor: '',
            acreditacion: ''
        }, {
            id: 10,
            titulo: 'ING. AGR.',
            nombre: 'AZARIEL JULIAN 10',
            apellidos: 'RIOS',
            puesto: 'inspector',
            estatus: 'activo',
            laptop: '8',
            celular: '442 232 3303',
            tarjeta: '5062 5416 0249 4525',
            vehiculo: 'honda city',
            imagen: 'https://www.trendtic.cl/wp-content/uploads/2018/05/003-Rub%C3%A9n-Belluomo-INFOR-2018.jpg',
            tutor: '',
            acreditacion: ''
        }, {
            id: 11,
            titulo: 'ING. AGR.',
            nombre: 'AZARIEL JULIAN 11',
            apellidos: 'RIOS',
            puesto: 'inspector',
            estatus: 'activo',
            laptop: '8',
            celular: '442 232 3303',
            tarjeta: '5062 5416 0249 4525',
            vehiculo: 'honda city',
            imagen: 'https://www.trendtic.cl/wp-content/uploads/2018/05/003-Rub%C3%A9n-Belluomo-INFOR-2018.jpg',
            tutor: '',
            acreditacion: ''
        }, {
            id: 12,
            titulo: 'ING. AGR.',
            nombre: 'AZARIEL JULIAN 12',
            apellidos: 'RIOS',
            puesto: 'inspector',
            estatus: 'activo',
            laptop: '8',
            celular: '442 232 3303',
            tarjeta: '5062 5416 0249 4525',
            vehiculo: 'honda city',
            imagen: 'https://www.trendtic.cl/wp-content/uploads/2018/05/003-Rub%C3%A9n-Belluomo-INFOR-2018.jpg',
            tutor: '',
            acreditacion: ''
        }, {
            id: 13,
            titulo: 'ING. AGR.',
            nombre: 'AZARIEL JULIAN 13',
            apellidos: 'RIOS',
            puesto: 'inspector',
            estatus: 'activo',
            laptop: '8',
            celular: '442 232 3303',
            tarjeta: '5062 5416 0249 4525',
            vehiculo: 'honda city',
            imagen: 'https://www.trendtic.cl/wp-content/uploads/2018/05/003-Rub%C3%A9n-Belluomo-INFOR-2018.jpg',
            tutor: '',
            acreditacion: ''
        }, {
            id: 14,
            titulo: 'ING. AGR.',
            nombre: 'AZARIEL JULIAN 14',
            apellidos: 'RIOS',
            puesto: 'inspector',
            estatus: 'activo',
            laptop: '8',
            celular: '442 232 3303',
            tarjeta: '5062 5416 0249 4525',
            vehiculo: 'honda city',
            imagen: 'https://www.trendtic.cl/wp-content/uploads/2018/05/003-Rub%C3%A9n-Belluomo-INFOR-2018.jpg',
            tutor: '',
            acreditacion: ''
        }, {
            id: 15,
            titulo: 'ING. AGR.',
            nombre: 'AZARIEL JULIAN 15',
            apellidos: 'RIOS',
            puesto: 'inspector',
            estatus: 'activo',
            laptop: '8',
            celular: '442 232 3303',
            tarjeta: '5062 5416 0249 4525',
            vehiculo: 'honda city',
            imagen: 'https://www.trendtic.cl/wp-content/uploads/2018/05/003-Rub%C3%A9n-Belluomo-INFOR-2018.jpg',
            tutor: '',
            acreditacion: ''
        }, {
            id: 16,
            titulo: 'ING. AGR.',
            nombre: 'AZARIEL JULIAN 16',
            apellidos: 'RIOS',
            puesto: 'inspector',
            estatus: 'activo',
            laptop: '8',
            celular: '442 232 3303',
            tarjeta: '5062 5416 0249 4525',
            vehiculo: 'honda city',
            imagen: 'https://www.trendtic.cl/wp-content/uploads/2018/05/003-Rub%C3%A9n-Belluomo-INFOR-2018.jpg',
            tutor: '',
            acreditacion: ''
        }, {
            id: 17,
            titulo: 'ING. AGR.',
            nombre: 'AZARIEL JULIAN 17',
            apellidos: 'RIOS',
            puesto: 'inspector',
            estatus: 'activo',
            laptop: '8',
            celular: '442 232 3303',
            tarjeta: '5062 5416 0249 4525',
            vehiculo: 'honda city',
            imagen: 'https://www.trendtic.cl/wp-content/uploads/2018/05/003-Rub%C3%A9n-Belluomo-INFOR-2018.jpg',
            tutor: '',
            acreditacion: ''
        }
    ],
}

const dataInicial = {
    inspectores: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const OBTENER_DATOS_GET_INSPECTORES_EXITO = 'OBTENER_DATOS_GET_INSPECTORES_EXITO'
const OBTENER_DATOS_GET_INSPECTOR_BY_ID_EXITO = 'OBTENER_DATOS_GET_INSPECTOR_BY_ID_EXITO'
const OBTENER_DATOS_GET_INSPECTOR_BY_ID_LOGIN_EXITO = 'OBTENER_DATOS_GET_INSPECTOR_BY_ID_LOGIN_EXITO'
const OBTENER_DATOS_GET_INSPECTOR_BY_ID_ZONA_EXITO = 'OBTENER_DATOS_GET_INSPECTOR_BY_ID_ZONA_EXITO'
const OBTENER_DATOS_GET_INSPECTOR_BY_NOMBRE_EXITO = 'OBTENER_DATOS_GET_INSPECTOR_BY_NOMBRE_EXITO'
const AGREGAR_DATOS_INSERT_INSPECTOR_EXITO = 'AGREGAR_DATOS_INSERT_INSPECTOR_EXITO'
const ACTUALIZAR_DATOS_UPDATE_INSPECTOR_EXITO = 'ACTUALIZAR_DATOS_UPDATE_INSPECTOR_EXITO'
const DAR_DE_BAJA_INSPECTOR_EXITO = 'DAR_DE_BAJA_INSPECTOR_EXITO'

const ACTUALIZAR_FIRMA_INSPECTOR_EXITO = 'ACTUALIZAR_FIRMA_INSPECTOR_EXITO'

const ACTUALIZAR_DATOS_PROMOVER_INSPECTOR_EXITO = 'ACTUALIZAR_DATOS_PROMOVER_INSPECTOR_EXITO'
const ELIMINAR_DATOS_ELIMINAR_INSPECTOR_EXITO = 'ELIMINAR_DATOS_ELIMINAR_INSPECTOR_EXITO'

//*******************************************************************************************************************




//MÉTODOS 
export const getInspectores = createAsyncThunk(
    OBTENER_DATOS_GET_INSPECTORES_EXITO,
    async () => {
        try {
            const fullUrl = host + `Inspectores/obtenerInspectores`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Inspectores: ' + JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getInspectorById = createAsyncThunk(
    OBTENER_DATOS_GET_INSPECTOR_BY_ID_EXITO,
    async (idInspector) => {
        try {
            const fullUrl = host + `Inspectores/obtenerInspectorById/${idInspector}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerInspectorByIdLogin = createAsyncThunk(
    OBTENER_DATOS_GET_INSPECTOR_BY_ID_LOGIN_EXITO,
    async (idlogin) => {
        try {
            const fullUrl = host + `Inspectores/obtenerInspectorByIdLogin/${idlogin}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getInspectorByIdZona = createAsyncThunk(
    OBTENER_DATOS_GET_INSPECTOR_BY_ID_ZONA_EXITO,
    async (idZona) => {
        try {
            const fullUrl = host + `Inspectores/getInspectorByIdZona/${idZona}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertInspector = createAsyncThunk(
    AGREGAR_DATOS_INSERT_INSPECTOR_EXITO,
    async (data) => {
        try {
            const datamain = { data: data.data }
            const imagen = data.image
            const fullUrl = host + `Inspectores/agregarInspector`
            const result = await axios.post(fullUrl, datamain)
            const fullUrl2 = host + `Inspectores/actualizarImagen`
            let formData = new FormData();
            formData.append(1, imagen)
            formData.append('idinspector', result.data.data.idinspector)
            const resFile = await axios.put(fullUrl2, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })

            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateInspector = createAsyncThunk(
    ACTUALIZAR_DATOS_UPDATE_INSPECTOR_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `Inspectores/actualizarInspector`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            const imagen = data.image
            const fullUrl2 = host + `Inspectores/actualizarImagen`
            let formData = new FormData();
            formData.append(1, imagen)
            formData.append('idinspector', result.data.data.idinspector)
            const resFile = await axios.put(fullUrl2, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })

            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateFirmaInspector = createAsyncThunk(
    ACTUALIZAR_FIRMA_INSPECTOR_EXITO,
    async (data) => {
        try {
            console.log(data)
            const imagen = data.image
            let formData = new FormData();
            formData.append(1, imagen)
            formData.append('idinspector', data.idinspector)
            const fullUrl = host + `Inspectores/actualizarFirmaInspector`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const promoverInspector = createAsyncThunk(
    ACTUALIZAR_DATOS_UPDATE_INSPECTOR_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `Inspectores/promoverInspector`
            alert("promover con:" + data)
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const darDeBajaInspector = createAsyncThunk(
    DAR_DE_BAJA_INSPECTOR_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `Inspectores/darDeBajaInspector`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteInspector = createAsyncThunk(
    ELIMINAR_DATOS_ELIMINAR_INSPECTOR_EXITO,
    async (idinspector) => {
        try {
            const fullUrl = host + `Inspectores/eliminarInspector/${idinspector}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosInspectorSlice = createSlice({

    name: 'metodosInspectorSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getInspectores.fulfilled]: (state, { payload }) => {
            state.inspectores = payload.data.data
        },
        [insertInspector.fulfilled]: (state, { payload }) => {

        },

        [updateInspector.fulfilled]: (state, { payload }) => {

        },

        [getInspectorById.fulfilled]: (state, { payload }) => {
            // state.data = payload.data
        },

        [getInspectorByIdZona.fulfilled]: (state, { payload }) => {
            // state.data = payload.data
        },
        [promoverInspector.fulfilled]: (state, { payload }) => {
            // state.data = payload.data
        },
        [darDeBajaInspector.fulfilled]: (state, { payload }) => {
            // state.data = payload.data
        },
        [deleteInspector.fulfilled]: (state, { payload }) => {
            // state.data = payload.data
        },
        [updateFirmaInspector.fulfilled]: (state, { payload }) => {
            // state.data = payload.data
        },
        [obtenerInspectorByIdLogin.fulfilled]: (state, { payload }) => {
            // state.data = payload.data
        },
    },

})


//ESTE NO SIRVE
export const InspectorSlice = createSlice({
    initialState: dataInicial,
    name: 'InspectorSlice',
    reducers: {
        agregarInspector(state, { payload }) {
            state.inspectores.push(payload)
        },
        editarInspector(state, { payload }) {
            console.log(payload)
            state.inspectores.map((inspector) => {
                if (inspector.id === payload.id) {
                    inspector.id = payload.id
                    inspector.titulo = payload.titulo
                    inspector.nombre = payload.nombre
                    inspector.apellidos = payload.apellidos
                    inspector.celular = payload.celular
                    inspector.puesto = payload.puesto
                    inspector.tarjeta = payload.tarjeta
                    inspector.estatus = payload.estatus,
                        inspector.laptop = payload.state,
                        inspector.vehiculo = payload.vehiculo,
                        inspector.tutor = payload.tutor
                }
            })
        },
        eliminarInspector(state, { payload }) {
            const filteredInspectores = state.inspectores.filter(inspector => inspector.id !== payload)
            state.inspectores = filteredInspectores
        },
        promoverInspector(state, { payload }) {
            console.log(payload)
            state.inspectores.map((inspector) => {
                if (inspector.id === payload.id) {
                    inspector.estatus = payload.estatus,
                        inspector.puesto = payload.puesto,
                        inspector.acreditacion = payload.acreditacion
                }
            })
        }
    }
})

/*export const {
    agregarInspector,
    eliminarInspector,
    editarInspector,
    promoverInspector
} = InspectorSlice.actions
*/
export const { } = metodosInspectorSlice.actions
export const InspectorReducer = metodosInspectorSlice.reducer